<template>
  <div>
    <AtomLoadingSecondary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapEnrollments',

  created () {
    this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.enrollments.subject')}/${this.$t('mEditionMenu.map.enrollments.children.students.subedition')}`)
  }
}
</script>
